import { render, staticRenderFns } from "./RuleTrigger.vue?vue&type=template&id=65c0d655&scoped=true&"
import script from "./RuleTrigger.vue?vue&type=script&lang=ts&"
export * from "./RuleTrigger.vue?vue&type=script&lang=ts&"
import style0 from "./RuleTrigger.vue?vue&type=style&index=0&id=65c0d655&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c0d655",
  null
  
)

export default component.exports